import React from "react";
import {
  Modal,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "../assets/stylesheets/routerModal.css";

export const RouterModal = ({ open, onClose, router, routerImages, storeIcons }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  if (!router) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="router-modal-title"
      aria-describedby="router-modal-description"
      sx={{
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          backdropFilter: "blur(1px)",
        }
      }}
    >
      <Box 
        className="router-modal-wrapper"
        sx={{
          position: isMobile ? "relative" : "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "90%" : "600px",
          maxWidth: "90vw",
          bgcolor: "background.paper",
          boxShadow: 24,
          border: 0,
          overflow: "hidden",
        }}
      >
        {/* Close button */}
        <CloseIcon 
          onClick={onClose} 
          className="router-modal-close"
        />

        {/* Modal content */}
        <Box 
          className="router-modal-content"
          sx={{
            padding: isMobile ? "40px 20px 20px 20px" : "60px 60px 30px 60px",
          }}
        >
          {/* Router title */}
          <Typography 
            variant="h5" 
            className="router-modal-title"
            sx={{
              fontFamily: "Figtree-Bold",
              color: "var(--grey)",
              fontSize: isMobile ? "1.3rem" : "1.5rem",
              marginBottom: "16px",
              textAlign: "left",
              lineHeight: 1.2,
            }}
          >
            {router.name}
          </Typography>

          {/* Store links and router image in flex row */}
          <Box 
            className="router-modal-body"
            sx={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? "16px" : "20px",
              alignItems: isMobile ? "center" : "flex-start",
            }}
          >
            {/* Store links */}
            <Box 
              className="router-modal-stores"
              sx={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                width: isMobile ? "100%" : "default",
                justifyContent: isMobile ? "center" : "default",
                gap: isMobile ? "10px" : "0px",
              }}
            >
              {router.links.map((link, index) =>
                link.link ? (
                  <Box 
                    key={link.name} 
                    className="router-modal-store-item"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      padding: isMobile ? "6px 0" : "8px 0",
                      columnGap: "3px",
                    }}
                  >
                    <img
                      src={storeIcons[link.name]}
                      alt={link.name}
                      className="router-modal-store-icon"
                    />
                    <Typography 
                      variant="body1" 
                      className="router-modal-store-name"
                      sx={{
                        color: "var(--grey)",
                        marginLeft: "8px",
                        fontSize: isMobile ? "1.1rem" : "1rem",
                      }}
                    >
                      {link.niceName}:
                    </Typography>
                    <a
                      href={link.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="router-modal-store-link"
                      style={{
                        fontFamily: "Figtree-Bold",
                        color: "var(--blue)",
                        textDecoration: "underline",
                        marginLeft: "8px",
                        fontSize: isMobile ? "1.1rem" : "1rem",
                      }}
                    >
                      Buy
                    </a>
                  </Box>
                ) : null
              )}
            </Box>

            {/* Router image */}
            <Box 
              className="router-modal-image-container"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                margin: 0,
              }}
            >
              <img
                src={routerImages[router.name]}
                alt={router.name}
                className="router-modal-image"
              />
            </Box>
          </Box>

          {/* Disclaimer */}
          <Typography 
            variant="body2" 
            className="router-modal-disclaimer"
            sx={{
              fontFamily: "Figtree-Regular",
              color: "var(--grey)",
              textAlign: "center",
              marginTop: isMobile ? "16px" : "20px",
              fontSize: isMobile ? "0.8rem" : "0.875rem",
              lineHeight: 1.4,
            }}
          >
            Please note that we do not endorse these products and we don't receive any payment if you purchase from these links.
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
}; 